import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from'../Component/Header';  
import Footer from'../Component/Footer';   
const CampusInformation = () => {  
  useEffect(() => {
    document.title = 'Campus Information - St. Francis Xavier School';  
}, []); 
    return (
        <>
        <Header/>
            <div className="innerslide">
                <ul className="breadcrumb">
                    <li><Link to="/"> Home</Link> </li>  
                    <li>School</li>
                    <li>Campus Information</li>
                </ul>
            </div> 
            <section className="innerbody">
            <div className="container"> 
                    <div className="row">
                    <div className="col-lg-12">
                    <div className="table-responsive maintable">
                    <table className="table">
                    <tbody>
                        <tr>
                          <td><strong>1.&nbsp;Area of school campus</strong></td>
                          <td>&nbsp;</td>
                        </tr>
                        <tr>
                          <td>(i) In acres</td>
                          <td>15 Acres</td>
                        </tr>
                        <tr>
                          <td>(ii) In sq. mtrs.</td>
                          <td>60703 sq. mts.</td>
                        </tr>
                        <tr>
                          <td>(iii)Built up are (sq. mts)</td>
                          <td>57000 sq. ft.</td>
                        </tr>
                        <tr>
                          <td>(iv) Area of playground in sq. mts.</td>
                          <td>16188 sq. mts.</td>
                        </tr>
                        <tr>
                          <td><strong>2.&nbsp;Other facilities</strong></td>
                          <td>&nbsp;</td>
                        </tr>
                        <tr>
                          <td>(i) Swimming pool</td>
                          <td>No</td>
                        </tr>
                        <tr>
                          <td>(ii) Indoor games</td>
                          <td>Yes</td>
                        </tr>
                        <tr>
                          <td>(iii) Dance Rooms</td>
                          <td>Yes</td>
                        </tr>
                        <tr>
                          <td>(iv) Gymnasium</td>
                          <td>No</td>
                        </tr>
                        <tr>
                          <td>(v) Music Rooms</td>
                          <td>Yes</td>
                        </tr>
                        <tr>
                          <td>(vi) Hostels</td>
                          <td>No</td>
                        </tr>
                        <tr>
                          <td>(vii) Health &amp; Medical checkup</td>
                          <td>Yes</td>
                        </tr>
                        <tr>
                          <td><strong>3.&nbsp;Transport facility</strong></td>
                          <td>&nbsp;</td>
                        </tr>
                        <tr>
                          <td>(i) Own buses</td>
                          <td>No.</td>
                        </tr>
                        <tr>
                          <td>(ii) Buses hired on contract basis</td>
                          <td>Yes</td>
                        </tr>
                        <tr>
                          <td>(iii) Details of transport charges</td>
                          <td>---</td>
                        </tr>
                        <tr>
                          <td><strong>4.&nbsp;Mode of payment of salary</strong></td>
                          <td>&nbsp;</td>
                        </tr>
                        <tr>
                          <td>(i) Name of the bank through which salary is drawing</td>
                          <td>Jammu and Kashmir Bank Hisar</td>
                        </tr>
                        <tr>
                          <td>(ii) Through single cheque transfer advice</td>
                          <td>Yes</td>
                        </tr>
                        <tr>
                          <td>(iii) Individual cheque</td>
                          <td>No</td>
                        </tr>
                        <tr>
                          <td>(iv) Cash</td>
                          <td>No</td>
                        </tr>
                        <tr>
                          <td><strong>5.&nbsp;Library facilities</strong></td>
                          <td></td>
                        </tr>
                        <tr>
                          <td>(i) size of the library in sq. feet</td>
                          <td>94 sq. mts</td>
                        </tr>
                        <tr>
                          <td>(ii) No. of periodicals</td>
                          <td>14</td>
                        </tr>
                        <tr>
                          <td>(iii) No. of Dailies</td>
                          <td>8</td>
                        </tr>
                        <tr>
                          <td>(iv) No. of reference books class wise</td>
                          <td>2020</td>
                        </tr>
                        <tr>
                          <td>(v) No. of Magazines</td>
                          <td>16</td>
                        </tr>
                        <tr>
                          <td>(vi) Others:</td>
                          <td>World books, science, encyclopedia, Dictionary,&nbsp;<br/>
                            fiction etc. - 1400</td>
                        </tr>
                        <tr>
                          <td><strong>6.&nbsp;Academic session period</strong></td>
                          <td>From April to March</td>
                        </tr>
                        <tr>
                          <td><strong>7.&nbsp;Vacation Period</strong></td>
                          <td>from 20th May to 2nd July</td>
                        </tr>
                        <tr>
                          <td><strong>8.&nbsp;Admission period</strong></td>
                          <td>from January to July</td>
                        </tr>
                      </tbody>
                    </table>
                    </div>
                    </div>
                    </div> 
                </div>
           </section>
           <Footer/>
        </>
    );
}

export default CampusInformation;
